<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">New Unit</p>
        <v-row class="my-0">
          <v-col class="py-0 mt-4" cols="12" sm="12" md="12">
            <v-text-field
              v-model="bedName"
              label="Unit Name"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="my-0">
          <v-col class="py-0" cols="12">
            <autocomplete-tags
              :items="property.tags"
              :tags="tags"
              unit-type="new_unit"
            ></autocomplete-tags>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            :disabled="loading || !bedName"
            @click="finish"
          >
            Finish
          </v-btn>
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import AutocompleteTags from './AutocompleteTags.vue'

export default {
  components: { AutocompleteTags },
  data() {
    return {
      bedName: '',
      dialog: false,
      newUnitTag: null,
      tags: [],
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      loading: true,
      parentAddressId: undefined
    }
  },
  computed: {
    property() {
      return this.$store.getters['properties/getProperty']
    }
  },
  methods: {
    /**
     * @param {{
     *  parentAddressId: string
     * }} props
     */
    open(props) {
      const { parentAddressId } = props
      this.dialog = true
      this.loading = false
      this.parentAddressId = parentAddressId
      this.$root.$setLoading(false)

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        this.loading = true
        this.$root.$setLoading(true)
        await this.$store.dispatch('units/newBedAction', {
          bedName: this.bedName,
          tags: this.tags.map((tag) => tag.text),
          parentAddressId: this.parentAddressId,
          index: 0
        })
        this.tags = []
        this.dialog = false
        this.loading = false
        this.$root.$setLoading(false)
        this.resolve(true)
      } catch (err) {
        this.$root
          .$confirm({
            title: 'New Unit Error',
            message: err,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'error'
            }
          })
          .then(() => {
            this.loading = false
            this.$root.$setLoading(false)
            this.reject(false)
          })
      }
    },
    cancel() {
      this.dialog = false
      this.resolve(false)
    }
  }
}
</script>
